import { AbstractControl, ValidatorFn } from '@angular/forms';

// Custom validator function to disallow additional cahracters in emails
export function CustomEmailValidatorAddOn(forbiddenChar: string): ValidatorFn {
    return (control: AbstractControl): { [key: string]: object } | null => {
        const forbidden = control.value.includes(forbiddenChar);
        return forbidden ? { 'email': { value: control.value } } : null;
    };
}